export * from './delete-besichtigungs-status.component';
export * from './delete-besichtigungs-status.component.module';